import {
    createSlice,
    createAsyncThunk
} from '@reduxjs/toolkit'
//import { terms } from '../../../server/controllers/users';


export const authenticateUser = createAsyncThunk(
    'user/authenticate',
    async ({ getState }) => {
        const url = process.env.REACT_APP_ACCOUNT_SERVER + "/authenticated"
        const res = await fetch(url, {
            method: 'GET',
            credentials: "include"
        }).then(
            (data) => data.json()
        )
        return res;
    }
)

export const loginUser = createAsyncThunk(
    'user/login',
    async (data) => {
        const url = process.env.REACT_APP_ACCOUNT_SERVER + "/login"
        const res = await fetch(url, {
            method: 'POST',
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
              },
            body: JSON.stringify(data)
        }).then(
            (data) => data.json()
        )
        return res;
    }
)

export const registerUser = createAsyncThunk(
    'user/register',
    async (data) => {
        const url = process.env.REACT_APP_ACCOUNT_SERVER + "/register"
        const res = await fetch(url, {
            method: 'POST',
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
              },
            body: JSON.stringify(data)
        }).then(
            (data) => data.json()
        )
        return res;
    }
)



export const updateProfile = createAsyncThunk(
    'user/updateProfile',
    async (user) => {
        const url = process.env.REACT_APP_ACCOUNT_SERVER + "/users/" + user.userId;
        const res = await fetch(url, {
            method: 'POST',
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
              },
            body: JSON.stringify(user)
        }).then(
            (data) => data.json()
        )
        return res;
    }
)

export const changePassword = createAsyncThunk(
    'user/changePassword',
    async ({ userId, currentPassword, newPassword }) => {
        const url = process.env.REACT_APP_ACCOUNT_SERVER + "/users/" + userId + "/password";
        const res = await fetch(url, {
            method: 'POST',
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
              },
            body: JSON.stringify({ currentPassword, newPassword })
        }).then(
            (data) => data.json()
        )
        return res;
    }
)

export const logoutUser = createAsyncThunk(
    'user/logout',
    async ({ getState }) => {
        const url = process.env.REACT_APP_ACCOUNT_SERVER + "/logout"
        const res = await fetch(url, {
            method: 'GET',
            credentials: "include"
        }).then(
            (data) => data.json()
        )
        return res;
    }
)


export const acceptTerms = createAsyncThunk(
    'user/acceptTerms',
    async (user) => {
        const url = process.env.REACT_APP_ACCOUNT_SERVER + "/users/" + user.userId + "/terms/";
        const res = await fetch(url, {
            method: 'POST',
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
              }
        }).then(
            (data) => data.json()
        )
        return res;
    }
)


export const userSlice = createSlice({
    name: 'user',
    initialState: {
        isWaiting: false,
        authenticated: false,
        hasAuthenticated: false,
        userId: "",
        admin: false,
        email: "",
        location: "",
        screenName: "",
        terms: 0,
    },

    reducers: {
        increment: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.value += 1
        },
    },
    extraReducers: {
        [loginUser.fulfilled]: (state, data) => {
            const {payload} = data;
            if (payload.success) {
                state.authenticated = true;
                state.hasAuthenticated = true;
                state.userId = payload.user.userId;
                state.admin = payload.user.admin;
                state.email = payload.user.email;
                state.location = payload.user.location;
                state.screenName = payload.user.screenName;
                state.terms = payload.user.terms;
            } else {
                state.authenticated = false;
                state.hasAuthenticated = true;
            }
        },
        [updateProfile.fulfilled]: (state, data) => {
            const {payload} = data;
            if (payload.success) {
                state.screenName = payload.user.screenName;
            }
        },
        [loginUser.rejected]: (state, { payload }) => {
            state.authenticated = false;
            state.hasAuthenticated = true;
        },
        [acceptTerms.fulfilled]: (state, data) => {
            const {payload} = data;
            if (payload.success) {
                state.terms = payload.user.terms;
            }
        },
        [authenticateUser.fulfilled]: (state, data) => {
            const {payload} = data;
            if (payload.success) {
                state.authenticated = true;
                state.hasAuthenticated = true;
                state.userId = payload.user.userId;
                state.admin = payload.user.admin;
                state.email = payload.user.email;
                state.location = payload.user.location;
                state.screenName = payload.user.screenName;
                state.terms = payload.user.terms;
            } else {
                state.authenticated = false;
                state.hasAuthenticated = true;
            }
        },
        [authenticateUser.rejected]: (state, { payload }) => {
            state.authenticated = false;
            state.hasAuthenticated = true;

        },
        [logoutUser.fulfilled]: (state, { payload }) => {
            if (payload.success) {
                state.authenticated = false;
                state.userId = null;
            }
        },
        [loginUser.fulfilled]: (state, { payload }) => {
            if (payload.success) {
                state.authenticated = false;
                state.userId = null;
            }
        },
    }
})

// Extract the action creators object and the reducer
export const userReducer = userSlice.reducer;